import { type PaginationConfigs } from './pagination.types'

export const CONFIGS_BY_ID: PaginationConfigs = {
  'expense-summary': {
    defaultPagination: {
      orderBy: '-id',
    },
    mode: 'url',
  },
  'user-list': {
    defaultPagination: {
      orderBy: 'firstName',
    },
    mode: 'url',
  },
  role: {
    defaultPagination: {
      orderBy: '-name',
    },
    mode: 'local',
  },
  'audit-log': {
    mode: 'local',
  },
  'primary-category-list': {
    defaultPagination: {
      orderBy: 'name',
    },
    mode: 'url',
  },
  'reconciliation-transaction-list': {
    defaultPagination: {
      orderBy: '-transaction_datetime',
      pageSize: 50,
    },
    mode: 'url',
  },
  'transaction-list': {
    defaultPagination: {
      orderBy: '-transaction_datetime',
    },
    mode: 'url',
  },
  'detailed-card-list': {
    defaultPagination: {
      orderBy: 'cardholder_first_name',
    },
    mode: 'url',
  },
  'punchout-connection-logs': {
    defaultPagination: {
      orderBy: '-created_at',
    },
    mode: 'url',
  },
  'vendor-list': {
    defaultPagination: {
      orderBy: 'name',
    },
    mode: 'local',
  },
  'approvable-payment-list': {
    defaultPagination: {
      orderBy: '-submitted_at',
      pageSize: 100,
    },
    mode: 'url',
  },
  'approvable-expense-list': {
    defaultPagination: {
      orderBy: '-id',
    },
    mode: 'url',
  },
  'legal-entity-list': {
    defaultPagination: {
      orderBy: 'name',
    },
    mode: 'local',
  },
  'mileage-rate-preset-list': {
    mode: 'local',
  },
}
